const clone = value => {
  if (value === undefined) return undefined
  return JSON.parse(JSON.stringify(value))
}

const eventId = event => event && (event.id || event.messageId)

const eventSequence = event => {
  const value = Number(event && event.sequence)
  return Number.isSafeInteger(value) ? value : 0
}

const orderedActiveEvents = events => (events || [])
  .filter(event => event && !event.deleted && eventId(event))
  .slice()
  .sort((left, right) => (
    eventSequence(left) - eventSequence(right) ||
    String(eventId(left)).localeCompare(String(eventId(right)))
  ))

const eventToClientEvent = event => {
  if (!event || !eventId(event)) return null
  const record = clone(event)
  return {
    ...record,
    id: eventId(record),
    messageId: record.messageId || eventId(record)
  }
}

class ConversationEventClientWindow {
  constructor (conversationId) {
    this.conversationId = conversationId
    this.events = new Map()
  }

  ingest (events) {
    const eventIds = new Set()
    for (const event of events || []) {
      const id = eventId(event)
      if (!id) continue
      this.events.set(id, clone(event))
      eventIds.add(id)
    }
    return eventIds
  }

  orderedEvents () {
    return orderedActiveEvents(Array.from(this.events.values())).map(eventToClientEvent)
  }

  clientEvents () {
    return this.orderedEvents()
  }

  clientEventsForIds (eventIds) {
    const wanted = eventIds instanceof Set ? eventIds : new Set(eventIds || [])
    const events = []
    for (const id of wanted) {
      const event = this.events.get(id)
      if (event) events.push(event)
    }
    return orderedActiveEvents(events).map(eventToClientEvent).filter(Boolean)
  }

  eventCount () {
    return this.events.size
  }
}

module.exports = {
  ConversationEventClientWindow,
  eventId,
  eventSequence,
  eventToClientEvent,
  orderedActiveEvents
}
